import { Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
// Redux Store imports
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to sessionStorage
import baseReducer from "reducers/reducer";

import KATAMUNDI_APP from "containers/Katamundi_App";
import React, { Component } from "react";
import "App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AdBlockDetect from "react-ad-block-detect";
import Popup from "reactjs-popup";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Register/Register.css";
import TextTheme from "components/General/Text/TextTheme";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, baseReducer);
let store = createStore(persistedReducer);
let persistor = persistStore(store);

class App extends Component {
  render() {
    const options = {
      position: "bottom center",
      timeout: 5000,
      offset: "30px",
      transition: "scale",
    };

    return (
      <Provider store={store}>
        <AdBlockDetect>
          <Popup
            modal
            defaultOpen={true}
            closeOnDocumentClick={false}
            lockScroll
          >
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                margin: "10px",
              }}
            >
              <TextTheme
                message="It looks like you're using an Ad Blocker."
                className="text_medium text_bold text_dark_blue"
                textAlign="center"
              />
              <TextTheme
                message="We don't like ads either, but in order to keep our operations flowing, we need a source of funding. Please disable your ad-blocker and refresh the page to continue or consider purchasing a monthly membership to use Katamundi with no ads."
                className=" text_dark_blue"
                textAlign="center"
              />

              <RoundedButton
                title="&nbsp;&nbsp;&nbsp;Refresh&nbsp;&nbsp;&nbsp;"
                buttonClassName="background_dark_orange"
                textThemeClassName="text_medium text_white"
                float="none"
                handleOnClick={() => {
                  document.location.reload();
                }}
              />

              <RoundedButton
                title="&nbsp;&nbsp;&nbsp;Purchase Katamundi Pro&nbsp;&nbsp;&nbsp;"
                buttonClassName="background_dark_orange"
                textThemeClassName="text_medium text_white"
                float="none"
                handleOnClick={() => {
                  document.location.reload();
                }}
              />
            </div>
          </Popup>
        </AdBlockDetect>
        <AlertProvider template={AlertTemplate} {...options}>
          <PersistGate loading={null} persistor={persistor}>
            <KATAMUNDI_APP />
          </PersistGate>
        </AlertProvider>
      </Provider>
    );
  }
}

export default App;
